export default "__VITE_ASSET__0IhLLVGr__"